import styled from 'styled-components';

export const PermissionErrorSC = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(217, 217, 217, 0) 0%,
    rgba(24, 30, 52, 0.5) 51.04%,
    #181e34 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin-bottom: 10px;
  }

  .buttons {
    display: flex;
    flex-direction: column;

    button {
      &:first-child {
        margin-bottom: 10px;
      }
    }
  }
`;
